export default {
    TEXT_OTHER_DEVICES: 'Thiết bị khác',


    HEADER_TEXT_DATA_ROAMING: 'Cài đặt Chuyển vùng dữ liệu trên thiết bị',
    TITLE_DATA_ROAMING_1: 'Bước 1: Vào mục Di động',
    DESC_DATA_ROAMING_1: 'Vào chức năng “Cài đặt” của thiết bị, chọn mục “Di động”',
    TITLE_DATA_ROAMING_2: 'Bước 2: Chọn SIM',
    DESC_DATA_ROAMING_2: 'Chọn SIM bạn đã đăng ký dịch vụ Chuyển vùng Quốc tế',
    TITLE_DATA_ROAMING_3: 'Bước 3: Bật Chuyển vùng dữ liệu',
    DESC_DATA_ROAMING_3: 'Và kiểm tra kết nối. Nếu vẫn chưa sử dụng được, bạn chuyển sang bước 4.',
    TITLE_DATA_ROAMING_4: 'Bước 4: Kiểm tra mạng',
    DESC_DATA_ROAMING_4: 'Kiểm tra mạng đang kết nối có đúng với mạng được áp dụng trong phạm vi của gói cước không.<br>Nếu không đúng, bạn chuyển sang bước 5.<br>Xem hướng dẫn tra cứu phạm vi áp dụng <a class="clickable-redirect-type-2">tại đây</a>',
    TITLE_DATA_ROAMING_5: 'Bước 5: Lựa chọn mạng',
    DESC_DATA_ROAMING_5: 'Nhấn “Lựa chọn mạng” để cài đặt mạng kết nối',
    TITLE_DATA_ROAMING_6: 'Bước 6: Cài đặt mạng kết nối',
    DESC_DATA_ROAMING_6: 'Tắt chế độ tự động và chọn mạng phù hợp trong danh sách đang hiển thị.<br>Nếu không có mạng theo danh sách phạm vi áp dụng của gói cước, vui lòng liên hệ tổng đài <a href="tel:+84912481111">+8491 248 1111</a> để được hỗ trợ (miễn phí).',
    TITLE_DATA_ROAMING_OTHER_1: 'Bước 1: Vào mục Thẻ SIM và mạng di động',
    DESC_DATA_ROAMING_OTHER_1: 'Vào chức năng “Cài đặt” của thiết bị, chọn mục “ Thẻ SIM và Mạng di động”',
    TITLE_DATA_ROAMING_OTHER_2: 'Bước 2: Chọn Chuyển vùng dữ liệu',
    DESC_DATA_ROAMING_OTHER_2: 'Nhấn chọn mục “Chuyển vùng dữ liệu”',
    TITLE_DATA_ROAMING_OTHER_3: 'Bước 3: Bật Chuyển vùng Quốc tế',
    DESC_DATA_ROAMING_OTHER_3: 'Nhấn vào phần trạng thái và đổi thành “Luôn luôn”.<br>Nếu vẫn chưa dùng được, bạn chuyển sang bước 4.',
    TITLE_DATA_ROAMING_OTHER_4: 'Bước 4: Chọn SIM',
    DESC_DATA_ROAMING_OTHER_4: 'Quay lại màn hình cài đặt “Thẻ SIM và mạng di động”.<br>Lựa chọn thẻ SIM bạn muốn sử dụng dịch vụ Chuyển vùng quốc tế.',
    TITLE_DATA_ROAMING_OTHER_5: 'Bước 5: Lựa chọn mạng',
    DESC_DATA_ROAMING_OTHER_5: 'Chọn “Mạng di động” để cài đặt mạng kết nối',
    TITLE_DATA_ROAMING_OTHER_6: 'Bước 6: Kiểm tra mạng kết nối',
    DESC_DATA_ROAMING_OTHER_6: 'Tắt chế độ “Chọn mạng tự động” và kiểm tra mạng đang kết nối có đúng với mạng được áp dụng trong phạm vi của gói cước không. Nếu không đúng, chuyển bước 7.',
    TITLE_DATA_ROAMING_OTHER_7: 'Bước 7: Chọn mạng thủ công',
    DESC_DATA_ROAMING_OTHER_7: 'Chọn lại nhà mạng phù hợp với phạm vi áp dụng của gói cước đã đăng ký. Nếu vẫn không dùng được, vui lòng liên hệ tổng đài <a href="tel:+84912481111">+8491 248 1111</a> để được hỗ trợ (miễn phí).<br>Xem hướng dẫn tra cứu phạm vi áp dụng <a class="clickable-redirect-type-2">tại đây</a>',


    HEADER_TEXT_SCOPE: 'Tra cứu phạm vi áp dụng của gói cước đang sử dụng',
    TITLE_SCOPE_1: 'Bước 1: Vào mục Viễn thông',
    DESC_SCOPE_1: 'Trong màn hình chính của My VNPT, chọn “Viễn thông”',
    TITLE_SCOPE_2: 'Bước 2: Vào mục Di động',
    DESC_SCOPE_2: 'Tại “Dịch vụ của tôi”, chọn “Di động”',
    TITLE_SCOPE_3: 'Bước 3: Vào mục Chuyển vùng quốc tế',
    DESC_SCOPE_3: 'Tại “Tiện ích di động”, chọn “Chuyển vùng quốc tế”',
    TITLE_SCOPE_4: 'Bước 4: Xem thông tin gói cước',
    DESC_SCOPE_4: 'Nhấn vào biểu tượng chữ “i” để xem thông tin gói cước đang sử dụng',
    TITLE_SCOPE_5: 'Bước 5: Xem phạm vi áp dụng',
    DESC_SCOPE_5: 'Kéo màn hình xuống dưới và xem bảng Phạm vi áp dụng',


    HEADER_TEXT_REMAINING_TRAFFIC: 'Kiểm tra lưu lượng còn lại của gói cước đang sử dụng',
    TITLE_REMAINING_TRAFFIC_1: 'Bước 1: Vào mục Viễn thông',
    DESC_REMAINING_TRAFFIC_1: 'Trong màn hình chính của My VNPT, chọn “Viễn thông”',
    TITLE_REMAINING_TRAFFIC_2: 'Bước 2: Vào mục Di động',
    DESC_REMAINING_TRAFFIC_2: 'Tại “Dịch vụ của tôi”, chọn “Di động”',
    TITLE_REMAINING_TRAFFIC_3: 'Bước 3: Kiểm tra lưu lượng còn lại',
    DESC_REMAINING_TRAFFIC_3: 'Trong phần Lưu lượng còn lại bạn sẽ thấy thông tin lưu lượng sử dụng của các dịch vụ trong gói cước',


    HEADER_TEXT_CANCEL_SERVICE: 'Cách hủy dịch vụ',
    TITLE_CANCEL_SERVICE_1: 'Cách 1: Soạn tin nhắn',
    TITLE_CANCEL_SERVICE_2: 'Cách 2: Hủy trên ứng dụng My VNPT',
    DESC_CANCEL_SERVICE_1: 'Soạn HUY CVQT gửi 9123 hoặc IR OFF gửi 9123 (miễn phí)',
    DESC_CANCEL_SERVICE_2: 'Bước 1: Truy cập ứng dụng, chọn “Viễn thông”',
    DESC_CANCEL_SERVICE_3: 'Bước 2: Tại “Dịch vụ của tôi”, chọn “Di động”',
    DESC_CANCEL_SERVICE_4: 'Bước 3: Tại “Tiện ích di động”, chọn “Chuyển vùng quốc tế”',
    DESC_CANCEL_SERVICE_5: 'Bước 4: Nhấn vào biểu tượng bật tắt dịch vụ',
    DESC_CANCEL_SERVICE_6: 'Bước 5: Nhấn nút “Tắt dịch vụ”',


    HEADER_TEXT_CANCEL_PACKAGE: 'Cách hủy gói cước',
    TITLE_CANCEL_PACKAGE_1: 'Bước 1: Vào mục Viễn thông',
    DESC_CANCEL_PACKAGE_1: 'Trong màn hình chính của My VNPT, chọn “Viễn thông”',
    TITLE_CANCEL_PACKAGE_2: 'Bước 2: Vào mục Di động',
    DESC_CANCEL_PACKAGE_2: 'Tại “Dịch vụ của tôi”, chọn “Di động”',
    TITLE_CANCEL_PACKAGE_3: 'Bước 3: Chuyển vùng quốc tế',
    DESC_CANCEL_PACKAGE_3: 'Tại mục Tiện ích di động, chọn “Chuyển vùng quốc tế”',
    TITLE_CANCEL_PACKAGE_4: 'Bước 4: Xem thông tin gói cước',
    DESC_CANCEL_PACKAGE_4: 'Nhấn vào biểu tượng chữ “i” để xem thông tin gói cước đang sử dụng',
    TITLE_CANCEL_PACKAGE_5: 'Bước 5: Huỷ gói cước',
    DESC_CANCEL_PACKAGE_5: 'Nhấn nút “Huỷ gói”'


};